const START_LOADING = 'START_LOADING'
const STOP_LOADING = 'STOP_LOADING'
const START_SURVEYSUBMISSION_LOADING = 'START_SURVEYSUBMISSION_LOADING'
const STOP_SURVEYSUBMISSION_LOADING = 'STOP_SURVEYSUBMISSION_LOADING'

let forcedLoader = false

export const startLoader = (forced = false, type = null) => {
  if (type) {
    return {
      type: `START_${type.toUpperCase()}_LOADING`,
      forced,
      value: type
    }
  }
  return {
    type: START_LOADING,
    forced
  }
}

export const stopLoader = (forced = false, type = null) => {
  if (type) {
    return {
      type: `STOP_${type.toUpperCase()}_LOADING`,
      forced,
      value: type
    }
  }
  return {
    type: STOP_LOADING,
    forced
  }
}

const loading = (state, action = {}) => {
  const currentState = state === undefined ? false : state
  const newState = { ...currentState }
  switch (action.type) {
    case START_LOADING:
      if (action.forced) forcedLoader = true
      return { ...newState, general: true }
    case STOP_LOADING:
      if (!action.forced && forcedLoader) {
        return { ...newState, general: true }
      }
      forcedLoader = false
      return { ...newState, general: false }
    case START_SURVEYSUBMISSION_LOADING:
      return { ...newState, [action.value]: true }
    case STOP_SURVEYSUBMISSION_LOADING:
      return { ...newState, [action.value]: false }
    default:
      return currentState
  }
}

export const loadingActions = {
  startLoader,
  stopLoader
}

export default loading
